import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Collection from './pages/Collection';
import Product from './pages/Product';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import Account from './pages/Account';
import AdminPricing from './pages/AdminPricing';
import AdminSMMHype from './pages/AdminSMMHype';
import { AuthProvider } from './context/AuthContext';
import { OrdersProvider } from './context/OrdersContext';
import { LoyaltyProvider } from './context/LoyaltyContext';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';

// Detect the Emergent OAuth callback synchronously (before any route renders)
// so we never leak the session_id fragment or hit /auth/me too early.
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/collections" element={<Collection />} />
      <Route path="/collections/:slug" element={<Collection />} />
      <Route path="/product/:productId" element={<Product />} />
      <Route path="/checkout/:productId" element={<Checkout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/auth/login" element={<Auth />} />
      <Route path="/auth/register" element={<Auth />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin/pricing" element={<AdminPricing />} />
      <Route path="/admin/smmhype" element={<AdminSMMHype />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <OrdersProvider>
          <LoyaltyProvider>
            <BrowserRouter>
              <ScrollToTop />
              <AppRouter />
            </BrowserRouter>
            <Toaster />
          </LoyaltyProvider>
        </OrdersProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
